import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M15 12.5C15.25 12.5 15.5 12.2812 15.5 12L15.5 5.625L13.375 3.5L9 3.5C8.71875 3.5 8.5 3.75 8.5 4L8.5 12C8.5 12.2812 8.71875 12.5 9 12.5H15ZM9 14C7.875 14 7 13.125 7 12L7 4C7 2.90625 7.875 2 9 2L13.375 2C13.75 2 14.1562 2.1875 14.4375 2.46875L16.5312 4.5625C16.8125 4.84375 17 5.25 17 5.625V12C17 13.125 16.0938 14 15 14H9ZM5 6L6 6V7.5H5C4.71875 7.5 4.5 7.75 4.5 8L4.5 16C4.5 16.2812 4.71875 16.5 5 16.5H11C11.25 16.5 11.5 16.2812 11.5 16V15H13V16C13 17.125 12.0938 18 11 18H5C3.875 18 3 17.125 3 16L3 8C3 6.90625 3.875 6 5 6Z"
	})
});
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
